import React, { useState, useEffect } from 'react';
import LoginPage from './admin/pages/LoginPage';
import AdminDashboard from "./admin/pages/AdminDashboard.jsx";
import { safeStorage } from './admin/utils/storageHelper';
import { config } from './admin/utils/config';


function AppContent() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Direct check without timer
    const savedUser = safeStorage.getItem('user');

    if (savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        setUser(userData);
      } catch (error) {
        console.error('AppContent: Error parsing user data:', error);
        safeStorage.removeItem('user');
      }
    } else {
    }

    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    safeStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = async () => {
    try {
      const token = user?.token || safeStorage.getItem('authToken');
      if (token) {
        await fetch(`${config.API_BASE_URL}${config.API_PREFIX}/api/v1/admin/auth/logout/`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      }
    } catch (error) {
      console.error("Logout API failed", error);
    } finally {
      setUser(null);
      safeStorage.removeItem('user');
      safeStorage.removeItem('authToken');
      sessionStorage.removeItem('authToken');
    }
  };

  useEffect(() => {
    let logoutTimer;

    if (user && user.token) {
      try {
        const payloadBase64 = user.token.split('.')[1];
        if (payloadBase64) {
          const decodedPayload = JSON.parse(atob(payloadBase64));

          if (decodedPayload.exp) {
            const currentTime = Math.floor(Date.now() / 1000);
            const timeLeft = decodedPayload.exp - currentTime;
            // const timeLeft = 10; // TEMPORARY TESTING: Force 5 seconds 

            if (timeLeft <= 0) {
              handleLogout();
            } else {
              logoutTimer = setTimeout(() => {
                alert("Your session has expired. Please log in again.");
                handleLogout();
              }, timeLeft * 1000);
            }
          }
        }
      } catch (e) {
        console.error("Failed to decode token for auto-logout", e);
      }
    }

    return () => {
      if (logoutTimer) clearTimeout(logoutTimer);
    };
  }, [user]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        fontFamily: 'Arial, sans-serif',
        background: 'linear-gradient(135deg, #F55D00 0%, #FDBF50 100%)',
        color: 'white'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid rgba(255,255,255,0.3)',
          borderTop: '4px solid #ffffff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '20px'
        }}></div>
        <p>Loading Kirazee Dashboard...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // If no user, show login page
  if (!user) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <AdminDashboard />
    </div>
  );

}

export default AppContent;
